export const ELEMENTS_LOAD = 'ELEMENTS_LOAD';
export const ELEMENTS_RESET_SCORES = 'ELEMENTS_RESET_SCORES';
